import type { FileStorageConfiguration } from "../types/FileStorageConfiguration"

export const DefaultBackend: FileStorageConfiguration = {
  enum: "Browser",
  db: "Files",
}
